export const environment = {
  production: true,
  apiUrl: 'https://hom.api.ms.gov.br/participams/',
  ta: '',
  h: '',
  dataVersao: '',
  ambiente: 'Homologação',
  grantType: 'client_credentials',
  client_id: 'participa-ms',
  client_secret: 'efe55f75-7d1f-444c-a4fe-ffb017ca2490'
};